// extracted by mini-css-extract-plugin
module.exports = {"main":"Info_main__3xXaJ","main__title":"Info_main__title__2TIXd","main__info":"Info_main__info__1WUKT"};